// blog data

export const Blogs = [
    {
        id:1,
        name:"Chaos to Clarity: A Guide to Crafting Better Essays",
        tags:["writing","essays","education"],
        date:"16 October, 2024",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736448818/essay-blog-image_dn7esk.png",
        link:"https://medium.com/@creativecompiler/chaos-to-clarity-a-guide-to-crafting-better-essays-7dfe4e6ecc50"
    },
    {
        id:2,
        name:"Coming Soon... How I Learnt Python",
        tags:["python","beginner-to-advanced"],
        date:"25 January, 2024",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736449063/python_-_blog_-_image_u86oul.png",
        link:""
    },
    {
        id:3,
        name:"Coming Soon... Machine Learning? What's That?",
        tags:["ML","AI","research", "from-experience"],
        date:"5 February, 2024",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736449364/ML-blog-image_lplzid.png",
        link:""
    },
    {
        id:4,
        name:"Coming Soon... What the Process of Pursuing Studies Abroad Looks Like",
        tags:["international-student","abroad","change"],
        date:"12 February, 2024",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736449718/internationalstudent-blog-image_p1dqn1.png",
        link:""
    },
    {
        id:5,
        name:"COMING SOON",
        tags:["international-student","abroad","change"],
        date:"DD MM, YYYY",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736509522/rnadom_ksbayb.png",
        link:""
    },
    {
        id:6,
        name:"COMING SOON",
        tags:["international-student","abroad","change"],
        date:"DD MM, YYYY",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736509522/rnadom_ksbayb.png",
        link:""
    },
    {
        id:7,
        name:"COMING SOON",
        tags:["international-student","abroad","change"],
        date:"DD MM, YYYY",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736509522/rnadom_ksbayb.png",
        link:""
    },
    {
        id:8,
        name:"COMING SOON",
        tags:["international-student","abroad","change"],
        date:"DD MM, YYYY",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736509522/rnadom_ksbayb.png",
        link:""
    },
    {
        id:9,
        name:"COMING SOON",
        tags:["international-student","abroad","change"],
        date:"DD MM, YYYY",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736509522/rnadom_ksbayb.png",
        link:""
    },
    {
        id:10,
        name:"COMING SOON",
        tags:["international-student","abroad","change"],
        date:"DD MM, YYYY",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736509522/rnadom_ksbayb.png",
        link:""
    },
    {
        id:11,
        name:"COMING SOON",
        tags:["international-student","abroad","change"],
        date:"DD MM, YYYY",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736509522/rnadom_ksbayb.png",
        link:""
    },
    {
        id:12,
        name:"COMING SOON",
        tags:["international-student","abroad","change"],
        date:"DD MM, YYYY",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736509522/rnadom_ksbayb.png",
        link:""
    },
    {
        id:13,
        name:"COMING SOON",
        tags:["international-student","abroad","change"],
        date:"DD MM, YYYY",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736509522/rnadom_ksbayb.png",
        link:""
    },
    {
        id:14,
        name:"COMING SOON",
        tags:["international-student","abroad","change"],
        date:"DD MM, YYYY",
        imgSrc:"https://res.cloudinary.com/dblzw1rpg/image/upload/v1736509522/rnadom_ksbayb.png",
        link:""
    }

  
] 